// Content (Italian). Multi-page site: commercial Home + deep-dive support pages.

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Guide", to: "/guide" },
  { label: "Strategie", to: "/strategie" },
  { label: "Notifiche pronte", to: "/notifiche" },
  { label: "FAQ", to: "/faq" },
];

// ---------- HOME (commercial) ----------
export const HOME_JOURNEY = [
  { step: "01", title: "Vede il QR Code", text: "Il cliente inquadra il QR esposto in negozio, in vetrina o alla cassa." },
  { step: "02", title: "Si iscrive", text: "Bastano pochi secondi: nessun download dagli store, solo un link." },
  { step: "03", title: "Aggiunge l'app", text: "La tua web app finisce sulla schermata iniziale del suo telefono." },
  { step: "04", title: "Consulta i contenuti", text: "News, eventi e promozioni sempre aggiornati e a portata di mano." },
  { step: "05", title: "Riceve le notifiche", text: "I tuoi messaggi arrivano dritti sullo smartphone, quando serve." },
  { step: "06", title: "Torna in negozio", text: "Più visite, più acquisti, più clienti che tornano da te." },
];

export const FEATURES = [
  { icon: "Bell", title: "Notifiche Push", text: "Raggiungi i clienti direttamente sullo smartphone. Lo strumento più efficace per farli tornare." },
  { icon: "Newspaper", title: "News", text: "Comunica nuovi prodotti, orari e arrivi con contenuti sempre consultabili nell'app." },
  { icon: "CalendarDays", title: "Eventi", text: "Open day, anteprime e iniziative con data, luogo e prenotazione. Gli eventi scaduti spariscono da soli." },
  { icon: "Tag", title: "Promozioni", text: "Offerte riservate agli iscritti, anche a numero chiuso con conferma automatica via email." },
  { icon: "QrCode", title: "QR Code", text: "Iscrizioni facili in negozio: esponi il QR dove il cliente è pronto ad agire." },
  { icon: "BarChart3", title: "Statistiche", text: "Iscritti, notifiche inviate e tasso di lettura: capisci cosa funziona davvero." },
  { icon: "Users", title: "Segmentazione", text: "Invia il messaggio giusto al pubblico giusto e aumenta la rilevanza." },
  { icon: "Smartphone", title: "Gestione Mobile", text: "Gestisci tutto da smartphone, tablet o PC, ovunque ti trovi." },
];

export const EXISTING_USER_CARDS = [
  { icon: "BookOpen", title: "Guide passo-passo", text: "Tutorial dedicati: come creare news, eventi, promozioni, inviare notifiche e altro.", to: "/guide" },
  { icon: "Target", title: "Strategie", text: "Mix mensile, calendario annuale e idee pratiche per il tuo settore.", to: "/strategie" },
  { icon: "Bell", title: "50 notifiche pronte", text: "Testi pronti da copiare e inviare per ogni occasione.", to: "/notifiche" },
  { icon: "ClipboardCheck", title: "Errori & Checklist", text: "Cosa evitare e la routine mensile per risultati costanti.", to: "/checklist" },
];

export const PRICING_FEATURES = [
  "Web app personalizzata con il tuo logo e i tuoi colori",
  "Notifiche push illimitate ai tuoi iscritti",
  "News, eventi e promozioni gestibili da mobile o PC",
  "QR Code per iscrizioni facili in negozio",
  "Segmentazione e statistiche complete",
  "Database di tua proprietà, dati sempre al sicuro",
  "Configurazione iniziale curata dal team PushApp",
  "Assistenza e supporto dedicati",
];

// ---------- Step-by-step guides (hub + detail pages) ----------
export const GUIDE_MODULES = [
  {
    slug: "accesso-al-pannello",
    icon: "LogIn",
    title: "Accedere al pannello",
    intro: "Il pannello di gestione è accessibile da computer, tablet o smartphone con il link e le credenziali ricevute in fase di attivazione.",
    steps: [
      "Apri il link del pannello con il browser",
      "Inserisci username o indirizzo email",
      "Inserisci la password e premi Accedi",
      "Attendi il caricamento della dashboard",
    ],
    tips: [
      "Da smartphone, ruota il dispositivo in orizzontale per visualizzare meglio i campi.",
      "Conserva le credenziali ricevute in attivazione in un luogo sicuro.",
    ],
  },
  {
    slug: "la-dashboard",
    icon: "LayoutDashboard",
    title: "Usare la Dashboard",
    intro: "La dashboard è il tuo punto di partenza: mostra gli indicatori principali e dà accesso a tutte le sezioni.",
    steps: [
      "Controlla gli indicatori: iscritti, notifiche inviate, contenuti",
      "Raggiungi le sezioni: News, Eventi, Promozioni, Notifiche",
      "Identifica sempre il tipo di contenuto prima di pubblicare",
    ],
    tips: [
      "Chiediti sempre: è una news, un evento, una promozione o una notifica?",
      "Dai un'occhiata agli indicatori almeno una volta a settimana.",
    ],
  },
  {
    slug: "far-iscrivere-i-clienti",
    icon: "QrCode",
    title: "Far iscrivere i clienti",
    intro: "L'app cresce con gli iscritti. Il QR Code va esposto dove il cliente è più disponibile ad agire.",
    steps: [
      "Esponi il QR: vetrina, cassa, bancone, camerino, packaging, sito, firma email, social",
      "Dai un motivo per iscriversi: sconto, omaggio, accesso anticipato ai saldi",
      "Cura il messaggio di benvenuto: ringrazia e ricorda il vantaggio",
      "Invita ad aggiungere l'app alla schermata iniziale",
    ],
    tips: [
      "Il QR funziona meglio dove il cliente è già fermo: cassa e bancone.",
      "Un piccolo incentivo aumenta moltissimo le iscrizioni.",
    ],
  },
  {
    slug: "creare-una-news",
    icon: "Newspaper",
    title: "Creare una News",
    intro: "Le news sono adatte a comunicazioni che restano consultabili nell'app: nuovi prodotti, orari, arrivi, aggiornamenti, collaborazioni.",
    steps: [
      "Scegli un titolo chiaro e specifico",
      "Scrivi un testo breve che riassuma il contenuto",
      "Aggiungi le informazioni davvero utili",
      "Carica un'immagine coerente e leggibile",
      "Scegli il pubblico (se hai la segmentazione)",
      "Decidi se inviare anche una notifica push",
      "Controlla l'anteprima e pubblica",
    ],
    tips: [
      "Invia la push solo quando il contenuto è importante o ha una scadenza.",
      "Un'immagine leggibile aumenta le aperture.",
    ],
  },
  {
    slug: "creare-un-evento",
    icon: "CalendarDays",
    title: "Creare un Evento",
    intro: "Gli eventi sono per contenuti legati a una data: open day, presentazioni, anteprime, iniziative speciali, promozioni stagionali.",
    steps: [
      "Inserisci titolo, data/orario e luogo",
      "Aggiungi descrizione, immagine, condizioni e costo",
      "Inserisci il link per prenotare e la data di scadenza",
      "Promuovi in 3 momenti: annuncio → promemoria → ultima chiamata",
      "Pubblica e controlla l'anteprima",
    ],
    tips: [
      "Imposta la data di scadenza: gli eventi finiti si rimuovono da soli e l'app resta ordinata.",
      "Il promemoria qualche giorno prima aumenta le presenze.",
    ],
  },
  {
    slug: "creare-una-promozione",
    icon: "Tag",
    title: "Creare una Promozione",
    intro: "Le promozioni sono vantaggi riservati agli iscritti per stimolare visite, acquisti o partecipazioni.",
    steps: [
      "Definisci COSA (il vantaggio), PER CHI, QUANDO e QUANTI",
      "Imposta, se vuoi, un numero massimo di adesioni (numero chiuso)",
      "L'utente aderisce con un clic e riceve conferma via email",
      "Esempio: sconto extra riservato ai primi 20 iscritti",
    ],
    tips: [
      "Le promo a numero chiuso creano urgenza reale ('solo i primi 20').",
      "Comunica sempre con chiarezza cosa, per chi, quando e quanti.",
    ],
  },
  {
    slug: "inviare-una-notifica-push",
    icon: "Bell",
    title: "Inviare una Notifica push",
    intro: "Le notifiche push sono messaggi brevi che arrivano direttamente sullo smartphone degli iscritti: lo strumento più efficace, da usare con equilibrio.",
    steps: [
      "Vai subito al punto, un solo messaggio per notifica",
      "Usa parole semplici ed evidenzia il vantaggio",
      "Indica chiaramente l'azione: vieni, prenota, scopri",
      "Segui la formula: [MOTIVO] → [INFORMAZIONE] → [AZIONE]",
      "Controlla l'anteprima e invia (o programma data e ora)",
    ],
    tips: [
      "Ritmo ideale: 1–2 notifiche a settimana; riduci se le adesioni calano.",
      "Una sola call to action per notifica.",
    ],
  },
  {
    slug: "utenti-e-statistiche",
    icon: "BarChart3",
    title: "Utenti & Statistiche",
    intro: "Nella sezione Utenti gestisci gli iscritti; nelle Statistiche capisci cosa funziona e parli al pubblico giusto.",
    steps: [
      "Sezione Utenti: gestisci gli iscritti e filtra con la segmentazione",
      "Statistiche: iscritti, notifiche inviate e tasso di lettura",
      "Valuta il tasso di apertura (un buon valore è 20–40%)",
      "Controlla i dati almeno una volta al mese e adatta i testi",
    ],
    tips: [
      "Una community piccola e attiva vale più di un database ampio e inattivo.",
      "Se le aperture calano, cambia testi e orari di invio.",
    ],
  },
];


// ---------- Strategy ----------
export const STRATEGY_GOALS = [
  "Portare clienti in negozio con offerte mirate",
  "Tenere i clienti aggiornati su news ed eventi",
  "Premiare i clienti fedeli con promozioni esclusive",
  "Riattivare chi non viene da un po'",
  "Fare nuovi clienti",
];

export const MONTHLY_MIX = [
  { count: "2", label: "Notifiche informative", note: "news / eventi" },
  { count: "2", label: "Notifiche promozionali", note: "offerte dedicate" },
  { count: "1", label: "Notifica personale", note: "fedeltà / compleanno" },
];

export const MONTHLY_PLAN = [
  { period: "Inizio mese", action: "Una novità o un contenuto interessante" },
  { period: "Metà mese", action: "Una promozione dedicata agli iscritti" },
  { period: "Fine mese", action: "Un invito a tornare o un piccolo regalo" },
];

export const ANNUAL_CALENDAR = [
  { month: "Gennaio", items: ["Capodanno", "Saldi invernali"] },
  { month: "Febbraio", items: ["San Valentino", "Carnevale"] },
  { month: "Marzo", items: ["Festa della Donna", "Inizio primavera"] },
  { month: "Aprile", items: ["Pasqua", "25 aprile"] },
  { month: "Maggio", items: ["Festa della Mamma", "Primo Maggio"] },
  { month: "Giugno", items: ["Festa del Papà", "Inizio estate / saldi"] },
  { month: "Luglio", items: ["Saldi estivi", "Offerte estate"] },
  { month: "Agosto", items: ["Ferragosto", "Offerte agosto"] },
  { month: "Settembre", items: ["Rientro / Back to school", "Fine estate"] },
  { month: "Ottobre", items: ["Halloween", "Offerte autunno"] },
  { month: "Novembre", items: ["Black Friday", "Offerte novembre"] },
  { month: "Dicembre", items: ["Natale", "Capodanno"] },
];

export const SECTORS = [
  { icon: "Store", name: "Negozio al dettaglio", text: "Promuovi nuovi arrivi e offerte flash. Usa la segmentazione per genere ed età.", image: "https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { icon: "Shirt", name: "Abbigliamento & Moda", text: "Anticipa nuove collezioni e saldi. Premia gli iscritti con anteprime riservate.", image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { icon: "Sparkles", name: "Profumeria & Beauty", text: "Comunica novità di prodotto, set regalo e reminder per ricariche e fedeltà.", image: "https://images.pexels.com/photos/7772165/pexels-photo-7772165.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { icon: "Scissors", name: "Parrucchiere & Estetica", text: "Promozioni stagionali, reminder appuntamenti e fedeltà dei clienti fissi.", image: "https://images.pexels.com/photos/7195800/pexels-photo-7195800.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { icon: "Dumbbell", name: "Palestra & Sport", text: "Avvisi corsi, rinnovi abbonamento e sfide mensili per la tua community.", image: "https://images.pexels.com/photos/4164761/pexels-photo-4164761.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { icon: "Coffee", name: "Bar & Ristorazione", text: "Menù del giorno, eventi e promozioni per riempire i momenti più tranquilli.", image: "https://images.pexels.com/photos/887827/pexels-photo-887827.jpeg?auto=compress&cs=tinysrgb&w=1200" },
];

// ---------- 50 ready-to-use notifications ----------
export const READY_NOTIFICATIONS = {
  Generali: [
    "Ciao! Oggi abbiamo una sorpresa per te. Vieni a trovarci!",
    "Novità in arrivo! Scopri cosa c'è di nuovo da [Nome attività].",
    "Solo per i nostri clienti app: sconto esclusivo questo weekend!",
    "Hai già visto le ultime novità? Apri l'app e scopri tutto.",
    "Ti aspettiamo! Oggi siamo aperti fino alle [ora].",
    "Grazie per essere con noi. Ecco un regalo per te.",
    "Mancano solo [X] giorni all'evento — segna la data!",
    "È tornata la tua promozione preferita. Non perdertela!",
    "Siamo tornati dalle ferie — benvenuto di nuovo!",
    "Novità di stagione: entra e scopri le ultime proposte.",
  ],
  "Negozi / Retail": [
    "Nuovo arrivo in negozio! Vieni a scoprirlo per primo.",
    "Oggi promo lampo: solo per chi entra entro le [ora]!",
    "Il prodotto che aspettavi è di nuovo disponibile.",
    "Sconto riservato ai clienti app: mostra questa notifica in cassa.",
    "Weekend di offerte! Vieni a trovarci e risparmia.",
    "Ultimi pezzi disponibili — affrettati prima che finiscano.",
    "Hai un buono fedeltà da usare. Passa a ritirarlo!",
    "Anteprima riservata: scopri la nuova selezione in vetrina.",
  ],
  "Abbigliamento / Moda": [
    "Nuova collezione appena arrivata. Vieni a scoprirla!",
    "Saldi: -30% su tutto. Solo fino a domenica.",
    "Ultimi pezzi disponibili — corri prima che finiscano!",
    "Esclusiva app: 10% in più sugli acquisti di oggi.",
    "Riceviamo i nuovi arrivi ogni giovedì — sii il primo!",
    "La tua taglia e i tuoi stili preferiti sono di nuovo disponibili.",
  ],
  "Estetica / Benessere": [
    "Il tuo appuntamento si avvicina — sei pronta/o?",
    "Nuovo trattamento disponibile. Prenota la tua prova gratuita.",
    "Pacchetto primavera: 3 trattamenti al prezzo di 2.",
    "Promozione compleanno: sconto speciale il mese del tuo compleanno!",
    "Regala benessere: buoni regalo disponibili in negozio.",
    "Ultime disponibilità di questo mese — prenota ora.",
  ],
  "Palestre / Sport": [
    "Nuovo corso disponibile: [nome corso]. Iscriviti subito!",
    "Il tuo abbonamento scade il [data] — rinnova e risparmia.",
    "Sfida del mese: vinci un mese gratis. Partecipa!",
    "Prova gratuita per un amico — porta chi vuoi questa settimana.",
    "App aggiornata con i tuoi progressi. Vai e controlla!",
    "Rinnova prima del [data] e ottieni 2 mesi al prezzo di 1.",
  ],
  "Profumeria / Beauty & Fedeltà": [
    "Nuovi profumi in arrivo — vieni a provarli in negozio.",
    "Set regalo in edizione limitata: disponibili solo questa settimana.",
    "Hai accumulato punti fedeltà! Convertili nel tuo prossimo acquisto.",
    "Campioni omaggio per i clienti app: passa a ritirarli.",
    "È ora di ricaricare il tuo prodotto preferito — sconto dedicato.",
    "Consulenza beauty gratuita su prenotazione. Prenota il tuo slot!",
    "Black Friday anticipato: offerte solo per clienti app.",
  ],
};

export const MISTAKES = [
  { title: "Mandare troppe notifiche", text: "Rischi di essere ignorato o disinstallato. Max 2-3 a settimana." },
  { title: "Testi troppo lunghi", text: "Le notifiche si leggono in 2 secondi. Sii breve e diretto." },
  { title: "Notifiche senza call to action", text: "Di' sempre cosa fare: \"vieni\", \"prenota\", \"scopri\"." },
  { title: "Ignorare le statistiche", text: "Controlla almeno una volta al mese e adatta la strategia." },
  { title: "Contenuti non aggiornati", text: "Tieni sempre freschi news, orari e promozioni." },
  { title: "Non segmentare il pubblico", text: "Usa i filtri per messaggi più rilevanti." },
];

export const CHECKLIST = [
  "Ho pubblicato almeno 1 news questo mese",
  "Ho inviato 2–4 notifiche push",
  "Ho aggiornato promozioni e orari in app",
  "Ho controllato le statistiche (iscrizioni, aperture)",
  "Ho pianificato le comunicazioni del mese prossimo",
  "Ho verificato che tutti i contenuti siano corretti e aggiornati",
];

export const FAQS = [
  { q: "Quante notifiche posso inviare?", a: "Non c'è un limite tecnico, ma consigliamo 1-2 a settimana (massimo 2-3) per restare efficaci senza stancare i clienti." },
  { q: "Come faccio a far iscrivere i clienti?", a: "Esponi il QR Code in negozio e invita i clienti a inquadrarlo. L'iscrizione richiede pochi secondi. Dai sempre un buon motivo per iscriversi (sconto, omaggio, anteprime)." },
  { q: "Posso inviare notifiche a gruppi specifici?", a: "Sì. Dalla sezione Utenti puoi filtrare e inviare a segmenti del tuo pubblico (es. per genere), quando la segmentazione è disponibile." },
  { q: "Posso programmare le notifiche in anticipo?", a: "Sì, puoi impostare data e ora di invio al momento della creazione del contenuto." },
  { q: "Posso modificare una notifica già inviata?", a: "No, una volta inviata non è modificabile. Puoi però inviarne una nuova con la correzione." },
  { q: "Cosa succede se un cliente disinstalla l'app?", a: "Non riceverà più notifiche. È normale: mantieni contenuti interessanti e utili per fidelizzare gli iscritti." },
  { q: "Come so se le notifiche funzionano?", a: "Controlla le statistiche: tasso di apertura, visualizzazioni dei contenuti e nuove iscrizioni. Se le aperture calano, varia testi e orari di invio." },
  { q: "I dati dei miei clienti sono al sicuro?", a: "Sì. I dati sono protetti e il database è di tua proprietà: solo tu vi accedi." },
  { q: "PushApp funziona su iPhone e Android?", a: "Sì. È una web app che funziona su qualsiasi smartphone moderno tramite browser e può essere aggiunta alla schermata iniziale, comportandosi come una vera app." },
  { q: "I clienti devono scaricare qualcosa dagli store?", a: "No. PushApp si apre da un semplice link o QR code: nessun download da App Store o Play Store. Per ricevere le notifiche basta iscriversi." },
  { q: "Posso personalizzare l'app con il mio brand?", a: "Sì: logo, colori, immagine di copertina, numero WhatsApp, email, profili social, collegamento recensioni, indicazioni stradali e fino a 5 link personalizzati." },
  { q: "Quanto tempo serve per attivare PushApp?", a: "L'app è già pronta: la configurazione iniziale è curata dal team PushApp. Bastano pochi giorni per personalizzarla e pubblicarla." },
  { q: "Cosa sono le promozioni a numero chiuso?", a: "Offerte con un numero massimo di adesioni (es. 'solo i primi 20'). L'utente aderisce con un clic e riceve conferma via email: creano urgenza e valore per gli iscritti." },
  { q: "Posso creare eventi con prenotazione?", a: "Sì. Puoi inserire titolo, data, luogo, descrizione, costo, immagine e link per prenotare. Gli eventi scaduti vengono rimossi automaticamente, così l'app resta ordinata." },
  { q: "Chi mi aiuta se ho un dubbio o un problema?", a: "Per consigli operativi (cosa scrivere, quali notifiche inviare) puoi chiedere ad Asia, l'assistente AI in basso a destra. Per assistenza tecnica o sull'account, contatta il team via email, telefono o WhatsApp." },
];
